export const en = {
  // Header
  header: {
    museumName: "Muzeul Antipa",
    audioTour: "Audio Tour",
    progress: "Progress",
    credits: "Info",
  },

  // Sidebar
  sidebar: {
    tourModes: {
      guided: "Guided Tour",
      free: "Free Explore",
    },
    audio: {
      available: "Audio Available",
      notAvailable: "No Audio Available",
      forAudioView: "This exhibit is for audio-view.",
      forViewingOnly: "This exhibit is for viewing only.",
      noAudio: "No audio",
    },
    visited: {
      markAsVisited: "Mark as Visited",
      markAsUnvisited: "Mark as Unvisited",
    },
    allExhibits: "All Exhibits",
  },

  // Stats Modal
  statsModal: {
    title: "Tour Progress",
    complete: "Complete",
    unvisitedExhibits: "Unvisited Exhibits",
    allExhibitsVisited: "All exhibits visited!",
    markAsCompleted: "Mark as Completed",
    restartTour: "Restart Tour",
  },

  // Museum Map
  museumMap: {
    customMap: "Custom Museum Map",
    artistDesign: "Artist's design will be placed here",
    noAudio: "No audio",
    autoCenterDisabled: "Auto-center disabled",
  },

  // Exhibits Data
  exhibits: {
    1: {
      title: "The Black Sea",
      description: "In the rhythm of the waves.",
      zone: "Romania's Biodiversity",
    },
    2: {
      title: "Danube Delta",
      description: "\"Birds' Paradise\".",
      zone: "Romania's Biodiversity",
    },
    3: {
      title: "Forest-Steppe and Continental Zone",
      description: "Sounds of nature from forests and fields.",
      zone: "Romania's Biodiversity",
    },
    4: {
      title: "Red deer attacked by wolves",
      description: "Wildlife in action.",
      zone: "Romania's Biodiversity",
    },
    5: {
      title: "Romania's Carpathians",
      description: "The mountains that come to life.",
      zone: "Romania's Biodiversity",
    },
    6: {
      title: "The Arctic and Antarctica",
      description: "Life at the Poles.",
      zone: "Earth's Biodiversity",
    },
    7: {
      title: "Terrestrial Bioregions",
      description: "South American Jungle, Pampas and Madagascar.",
      zone: "Earth's Biodiversity",
    },
    8: {
      title: "Oriental Bioregion",
      description: "Traveling through South and Southeast Asia.",
      zone: "Earth's Biodiversity",
    },
    9: {
      title: "Australian and New Zealand Bioregion",
      description: "Australia, New Guinea, New Zealand.",
      zone: "Earth's Biodiversity",
    },
    10: {
      title: "Africa",
      description: "Savannah in motion.",
      zone: "Earth's Biodiversity",
    },
  },

  // Credits Screen
  credits: {
    title: "Credits",
    subtitle: "Museum Tour",
    description: "Interactive Audio Experience",
    close: "Close",
    fundingDisclaimer: "\"Antipa Acoustic\" - the cultural project is co-financed by the National Cultural Fund Administration (AFCN). The project does not necessarily represent the position of the National Cultural Fund Administration. AFCN is not responsible for the content of the project or how the project results may be used. These are entirely the responsibility of the funding beneficiary.",
  },

  // Common
  common: {
    close: "✕",
    loading: "Loading...",
    error: "Error",
    success: "Success",
  },
};

export type Locale = typeof en; 